import { getAuthHeader } from '../tokenStorage';
import { axiosInstance } from './axiosInstance';

export const getRoleLabelsByProgramId = async (id) => {
  return axiosInstance.get(`/blapi/roleLabels/get/${id}`, {
    headers: getAuthHeader(),
  });
};
